import React from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "react-bootstrap";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../App";
import "./../../components/button/button.css";
import "./../../components/background/background.css";
import "react-datepicker/dist/react-datepicker.css";
import Image from "../../assets/background.png";
import Header from "../../components/header/header";
import { authentication } from "../../utils/config";
import { getReservation, deleteRerservation } from "../../utils/api";
import ReservCard from "../../components/reservCard/reservCard";
import "./reservList.css";
import Swal from "sweetalert2";
import ImageBack from "../../assets/back.png";
import mapping from "../../utils/areaMapping";

const ReservSuccess = () => {
  const navigate = useNavigate();
  const lineProfile = useContext(AuthContext);
  const [reservData, setreservData] = useState(null);
  const [isChange, setIsChange] = useState(false);
  useEffect(() => {
    let flag = true;

    // check line account
    const auth = async () => {
      const response = await authentication(lineProfile.userId);
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (
        response.data === "no user" ||
        response.data === "no vertification"
      )
        return navigate("/email");
      else if (response.data === "vertified") return navigate("/register");
      else if(response.data.clinic.vip === false) {
        await Swal.fire({
          title: "登錄產品後即可使用",
           
          icon: "warning",
        }) ;
        return navigate("/main") ;
      }
      flag = false;
    };

    const fetchReserv = async () => {
      if (flag) return;
      const response = await getReservation(lineProfile);
      if (response.error) return navigate("/error");
      else if (
        response.data === "not found reservation" ||
        response.data.reservations.length === 0
      )
        setreservData(null);
      else {
        const frameData = response.data.reservations.map((data) => {
          return {
            id: data.id,
            date: data.date.split("T")[0],
            time: data.time.substring(0, 5),
            type: data.type,
            clinicName: response.data.name,
            location: `${mapping[response.data.areaId]}${response.data.address}`,
          };
        });
        setreservData(frameData);
      }
    };

    const combine = async () => {
      await auth();
      await fetchReserv();
    };
    combine();
  }, []);

  //when pressing delete button, filter it from visual list
  const removeItem = (reservId) => {
    const filterReservData = reservData.filter((data) => data.id !== reservId);
    setreservData(filterReservData);
    console.log("here I delete it", filterReservData);
  };

  // sweet alert setting
  const customSwal = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-danger cancel-btn-spacing",
      cancelButton: "btn btn-success confirm-btn-spacing",
      actions: "swal-actions-spacing",
    },
    buttonsStyling: false,
  });

  async function showConfirmation(date, time, reservId, type) {
    const result = await customSwal.fire({
      title: "更改預約資訊",
      html:  `
      <div style="display: flex; justify-content: center;">
        <div style="text-align: left;">
             是否刪除或是修改預約<br>
             日期: <b>${date}</b> <br>
             時間: <b>${time}</b> <br>
             機型: <b>${type}</b> <br>
             的預約資訊?
        </div>
      </div>`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "取消預約",
      cancelButtonText: "更改時間",
      reverseButtons: true,
    });

    if (result.isConfirmed) {
      // call delete api
      setIsChange(!isChange);
      const response = await deleteRerservation(lineProfile, reservId);
      if (response.error) {
        await customSwal.fire({
          title: "發生錯誤",
          icon: "error",
        });
      } else if (response.data === "no reservation") {
        await customSwal.fire({
          title: "無此預約資訊",
          icon: "error",
        });
      } else {
        await customSwal.fire({
          title: "已取消預約",
          icon: "success",
        });
        removeItem(reservId);
      }
    } else if (result.dismiss === Swal.DismissReason.cancel) {
      navigate(`/reservchange?reservId=${reservId}`);
    }
  }

  const handleClick = async (data) => {
    const { id, date, time, type } = data;
    showConfirmation(date, time, id, type);
  };

  return (
    <Container
      fluid
      className="vh-100 d-flex flex-column  align-items-center backgroundStyle"
      style={{ backgroundImage: `url(${Image})` }}
    >
      <div className="w-100 mt-3">
      <Header title="待完成預約">
        <img
          src={ImageBack}
          alt="Back"
          style={{ width: "20px",  objectFit: "contain"}}
        />
      </Header>
      </div>
      <div className="reservList-record-list d-flex flex-column align-items-center">
        {!reservData && (
          <div
            className="text-center"
            style={{ height: "18vh", width: "45vh" }}
          >
            <p className="display-1">
              <b>No Data</b>
            </p>
          </div>
        )}
        {reservData &&
          reservData.map((data, index) => (
            <div key={data.id} style={{ width: "100%" }}>
              <ReservCard
                date={data.date}
                time={data.time}
                type={data.type}
                clinicName={data.clinicName}
                location={data.location}
                handleClick={() => handleClick(data)}
              />
              <br></br>
            </div>
          ))}
          <p className="h5 font-weight-bold">沒有更多了</p>
      </div>
    </Container>
  );
};

export default ReservSuccess;
